module.exports = __webpack_public_path__ + "img/LogoLoading_circle01.f1be447f.png";